import api from "utils/api";
import endpoint from "utils/endpoint";

type Store = {
  name: string;
  email: string;
};

type Staff = {
  name: string;
  email: string;
  role: string;
  password: string;
  password_confirmation: string;
};

class StoreRepository {
  public createStore({
    storeName,
    staffName,
    staffEmail,
    password,
    passwordConfirmation,
    role,
  }: {
    storeName: string;
    staffName: string;
    staffEmail: string;
    password: string;
    passwordConfirmation: string;
    role: string;
  }) {
    const body: {
      store: Store;
      staff: Staff;
    } = {
      store: { name: storeName, email: staffEmail },
      staff: {
        name: staffName,
        email: staffEmail,
        role,
        password,
        password_confirmation: passwordConfirmation,
      },
    };

    return api.post(endpoint.agency.stores.root(), body).catch((error) => {
      if (error.response) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    });
  }

  public async updateProfile({
    name,
    email,
    tel,
    fax,
    lineAccessToken,
    property,
    editLineAccessToken,
    editTakeoutStripeSecret,
  }: {
    name: string;
    email: string;
    tel: string;
    fax: string;
    lineAccessToken: string;
    property: {
      takeoutMinimumLeadTime: number;
      takeoutStripeSecret: string;
    };
    editLineAccessToken: boolean;
    editTakeoutStripeSecret: boolean;
  }) {
    return api.put(endpoint.store.store.root(), {
      store: {
        name,
        email,
        tel,
        fax,
        ...(editLineAccessToken
          ? { line_access_token: lineAccessToken ?? "" }
          : {}),
        property: {
          takeout_minimum_lead_time: property.takeoutMinimumLeadTime,
          ...(editTakeoutStripeSecret
            ? { takeout_raw_stripe_secret: property.takeoutStripeSecret ?? "" }
            : {}),
        },
      },
    });
  }

  public async delete(storeId: number) {
    return api.delete(endpoint.agency.stores.delete(storeId));
  }
}

export default new StoreRepository();
